import { useEffect, useRef, useState } from "react";

import AdminTable from "../AdminTable/AdminTable";

import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { Link } from 'react-router-dom';

import { Pencil } from "@phosphor-icons/react";

import "./listarCluster.css"

export default function TabelaListarCluster({
    cluster,
    filtros,
    setNotifier
}) {
    //Componentes reutilizados
    const iconeSubTabelaFechada = <KeyboardArrowRightIcon style={{width: '25px', height: '25px', cursor: 'pointer'}} />;
    const iconeSubTabelaAberta = <KeyboardArrowDownIcon style={{width: '25px', height: '25px', cursor: 'pointer'}} />;

    //Data
    const [ dados, setDados ] = useState(null);
    const tableData = {
        atributoKey: 'id_cluster',
        colunas: [
            { nome: '', atributo: 'iconeSubTabela', style: {width: '72px'} },
            { nome: 'Cluster', atributo: 'descricao' },
            { nome: 'Ação', atributo: 'acao', style: {width: '92px'}}
        ],
        dados: dados,

        temSubtabela: true
    };

    //Preencher data quando regiões forem atualizadas
    useEffect(() => {
        popularDadosTabela();

        //Usado para focar na filial filtrada
        if(filtros.id_filiais != 0) setTimeout(focarFilialConsultada);
        
    }, [ cluster ]);
    
    function popularDadosTabela() {
        if(typeof cluster !== 'undefined' && cluster !== null){
            setDados(cluster.map((clusters, index) => {
                const isSubTabelaAberta = 
                    filtros.id_filiais != 0 && clusters.filiais.map(f => f.id_filial).includes(filtros.id_filiais);

                const row = {
                    iconeSubTabela: isSubTabelaAberta ? iconeSubTabelaAberta : iconeSubTabelaFechada,
                    iconeSubTabela_onClick: () => abrirSubtabela(index),
                    
                    descricao: clusters.descricao,

                    acao:   <Link className='acaoGerenciamentoCluster' to="/admin/cluster/gerenciarcluster" state={{idClusterListar: clusters.id_cluster, descricaoClusterListar: clusters.descricao}}>
                                <Pencil/>
                            </Link>, 
                    
                    subtabelaAberta: isSubTabelaAberta,
                    subtabela: {
                        atributoKey: 'id_filial',
                        colunas: [
                            { nome: 'ID', atributo: 'id_filial', style: {width: '128px'} }, 
                            { nome: 'Filial', atributo: 'nome_filial' }
                        ],
                        dados: clusters.filiais.map(filial => ({
                            id_filial: filial.id_filial - 10000,
                            nome_filial: filial.nome_filial,
                            rowRef: filial.id_filial == filtros.id_filiais 
                                ? filialFiltradaRef
                                : undefined,
                            className: filial.id_filial == filtros.id_filiais
                                ? 'filial-regiao-filtrada'
                                : ''
                        }))
                    }
                }

                return row;
            }));
        }
    }

    function focarFilialConsultada() {
        if (filialFiltradaRef.current) {
            filialFiltradaRef.current.scrollIntoView({ behavior: 'smooth' });
            setTimeout(() => {
                window.scrollBy(0, -200);
            }, 500);
        }
    }

    //Utils
    const filialFiltradaRef = useRef(null);

    //Actions
    function abrirSubtabela(indexRow) {
        setDados((oldDados) => oldDados.map((row, index) => {
            if(indexRow == index){
                row.subtabelaAberta = !row.subtabelaAberta;
                
                row.iconeSubTabela = row.subtabelaAberta 
                    ? iconeSubTabelaAberta
                    : iconeSubTabelaFechada;
            }
            
            return row;
        }));
    }


    return <>
        <AdminTable
            atributoKey={tableData.atributoKey}
            colunas={tableData.colunas}
            dados={tableData.dados}
            temSubtabela={true}
            styleName={'tabela-habilitar-regioes'}
        />
    </>
}